import {Cascader} from 'antd'
import {createValue} from 'components/form/utils'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import {useAppConfig} from 'modules/local'
import Translate from 'modules/local/Translate'
import withTranslate from 'modules/local/withTranslate'
import React, {useContext, useMemo} from 'react'
import {compose, mapProps, pure} from 'recompose'
import {withAppConfig} from 'views/AppLocals/composers'
import {dropdownComponents, SelectWidget,} from 'views/AppLocals/custom/ReactSelectComponents'
import {SelectCountries} from 'views/Organization/Settings/SelectCountries'
import {NullAsDefault, renderOwnChild} from 'views/Shared'

const renderDefaultLabel = ({ name, type }) => (type ? `${type} ${name}` : name)

export const getProfileLocationOptions = ({
  wards,
  provinces,
  country_id,
  renderLabel = renderDefaultLabel,
}) => {
  const getWards = (province_id) =>
    _.filter(Array.from(wards || []), { province_id }).map(
      ({ id, name, type }) => ({
        value: id,
        label: renderLabel({
          name,
          type,
        }),
      })
    )

  return _.filter(Array.from(provinces || []), { country_id }).map(
    ({ id, name, type }) => ({
      value: id,
      label: renderLabel({
        name,
        type,
      }),
      children: getWards(id),
    })
  )
}

export const LocationCascade = ({
  name,
  value,
  onChange,
  country_id,
  defaultValue,
  Header = NullAsDefault,
  renderLabel,
  Wrapper = renderOwnChild,
  ...props
}) => {
  const { isSm } = useContext(LayoutContext)

  const appConfig = useAppConfig()

  const handleChange = (value) => {
    onChange(createValue(name, value))
  }

  const options = useMemo(
    () =>
      getProfileLocationOptions({
        ..._.pick(appConfig, ['provinces', 'wards']),
        country_id,
        renderLabel: isSm ? ({ name }) => name : renderDefaultLabel,
      }),
    [isSm, appConfig, country_id]
  )

  if (_.isEmpty(options)) return null

  return (
    <Wrapper>
      <Header />
      <Translate>
        {(translate) => (
          <Cascader
            showSearch={true}
            // changeOnSelect={true}
            suffixIcon={<dropdownComponents.DropdownIndicator />}
            {...props}
            value={value}
            options={options}
            onChange={handleChange}
            // className="block w-full"
            style={{
              width: '100%',
            }}
            placeholder={translate('Province/ward')}
            defaultValue={defaultValue}
            displayRender={(stringArray = []) =>
              stringArray.every(_.isEmpty)
                ? translate('Province/ward')
                : stringArray.join(' / ')
            }
          />
        )}
      </Translate>
    </Wrapper>
  )
}

export const renderLocationCascade = ({ Header, ...props }) => (
  <LocationCascade
    Header={Header}
    {...props}
  />
)

export const CountryPicker = compose(
  withTranslate,
  withAppConfig,
  mapProps(
    ({
      name,
      form,
      value,
      translate,
      appConfig,
      withChangedValues = (values) => ({}),
       allowClear = false
    }) => ({
      name,
      value,
      onChange: (value) => {
        const { values, setValues = NullAsDefault } = form || {}
        const hasLocationMeta = _.some(_.get(appConfig, 'provinces', []), {
          country_id: value,
        })
        if (!hasLocationMeta) {
          setValues({
            ...values,
            ...withChangedValues(values),
            [name]: value,
          })
        } else {
          setValues({
            ...values,
            [name]: value,
          })
        }
      },
      // onClear: () => {
      //   const { values, setValues = NullAsDefault } = form || {}
      //   setValues({
      //     ...values,
      //     [name]: null,
      //   })
      // },
      placeholder: translate('country'),
      Component: SelectWidget,
      allowClear
    })
  ),
  pure
)(SelectCountries)
